import * as CubiqTS from "shared/cubiq-model-multi-asset";

const ICON_WARNING: string = "icon_ion_warning_filled";
const ICON_ERROR: string = "icon_ion_error_filled";
const ICON_SUCCESS: string = "icon_ion_check_circle_filled";
const ICON_PENDING: string = "icon_ion_remove_circle_filled";

export class TradeStatusIconHelper {
  public ignoreSTPDisabledIcons: boolean = false;

  constructor() {
    // NO Op
  }

  getIcons(deal: CubiqTS.DealImpl): string {
    let icon: string = "icon-spacer";
    let description: string = "";

    // If deal is stp disabled and this is risk trades blotter (ignoreSTPDisabledIcons is on)
    // Ignore the icon
    if (
      CubiqTS.OrderDealState.DONE_NO_STP === deal.dealStateId &&
      this.ignoreSTPDisabledIcons === true
    ) {
      icon = "icon-spacer";
      description = "";
    } else if (
      deal.confirmedSalesUserId != null &&
      CubiqTS.OrderDealState.FILL_ERROR === deal.dealStateId
    ) {
      icon = ICON_WARNING;
    } else if (
      deal.confirmedSalesUserId != null &&
      CubiqTS.OrderDealState.FILL_ERROR !== deal.dealStateId
    ) {
      icon = ICON_SUCCESS;
    } else if (
      deal.confirmedSalesUserId == null &&
      CubiqTS.RequestOrderType.CALL != deal.requestOrderType &&
      CubiqTS.OrderDealState.ACK_TIME_OUT == deal.dealStateId
    ) {
      icon = ICON_ERROR;
    } else if (
      deal.confirmedSalesUserId == null &&
      CubiqTS.RequestOrderType.CALL != deal.requestOrderType &&
      CubiqTS.OrderDealState.NAK == deal.dealStateId
    ) {
      icon = ICON_ERROR;
    } else if (
      deal.confirmedSalesUserId == null &&
      CubiqTS.RequestOrderType.CALL != deal.requestOrderType &&
      CubiqTS.OrderDealState.DONE_NO_STP == deal.dealStateId
    ) {
      icon = ICON_WARNING;
    } else if (
      deal.confirmedSalesUserId == null &&
      CubiqTS.RequestOrderType.CALL != deal.requestOrderType &&
      CubiqTS.OrderDealState.STP_HOLD == deal.dealStateId
    ) {
      icon = ICON_WARNING;
    } else if (
      deal.confirmedSalesUserId == null &&
      CubiqTS.RequestOrderType.CALL != deal.requestOrderType &&
      CubiqTS.OrderDealState.FILL_ERROR == deal.dealStateId
    ) {
      icon = ICON_WARNING;
    } else if (
      CubiqTS.OrderDealState.FILL_PENDING == deal.dealStateId ||
      CubiqTS.OrderDealState.ACTIVE === deal.dealStateId ||
      CubiqTS.OrderDealState.PENDING == deal.dealStateId
    ) {
      icon = ICON_PENDING;
    }

    return `<i class="icon ${icon}" title="${description}"></i>`;
  }
}
